import type { ApiResponse, BillingSummary, Plan } from '@/types/api';

import { api } from './api';

export const billingService = {
  getSummary: async () => {
    const response = await api.get<ApiResponse<BillingSummary>>('/billing/me');
    return response.data.data;
  },

  requestCancellation: async () => {
    const response = await api.post<ApiResponse<{ message: string }>>('/billing/cancel-request');
    return response.data.data;
  },

  createCheckout: async (plan: Plan, cycle: 'monthly' | 'annual') => {
    const response = await api.post<ApiResponse<{ checkoutUrl: string; reference: string }>>(
      '/billing/checkout',
      { plan, cycle },
    );
    return response.data.data;
  },

  suspendUser: async (userId: number) => {
    const response = await api.post<ApiResponse<{ message: string }>>(
      `/billing/users/${userId}/suspend`,
    );
    return response.data.data;
  },

  reactivateUser: async (userId: number) => {
    const response = await api.post<ApiResponse<{ message: string }>>(
      `/billing/users/${userId}/reactivate`,
    );
    return response.data.data;
  },

  updateDueDate: async (userId: number, dueDate: string) => {
    const response = await api.patch<ApiResponse<{ nextBilling: string }>>(
      `/billing/users/${userId}/due-date`,
      { dueDate },
    );
    return response.data.data;
  },

  blockOverdueClient: async (userId: number) => {
    const response = await api.post<ApiResponse<{ message: string; userId: number }>>(
      `/billing/users/${userId}/block`,
    );
    return response.data.data;
  },

  unblockClient: async (userId: number) => {
    const response = await api.post<ApiResponse<{ message: string; userId: number }>>(
      `/billing/users/${userId}/unblock`,
    );
    return response.data.data;
  },
};
